/**
 * Avisos notorios en el navegador: sonido, notificación de escritorio y
 * título de la pestaña que parpadea.
 *
 * Los sonidos son los mismos que usa la app móvil (public/sonidos/). Qué tipo
 * suena con cuál lo dice el catálogo del backend (config/notifications.php,
 * campo 'sound'); acá sólo se reproducen.
 */

const ARCHIVOS = {
    lead_nuevo: '/sonidos/lead_nuevo.wav',
    lead_asignado: '/sonidos/lead_asignado.wav',
};

const audios = {};
let desbloqueado = false;
let ultimoSonido = 0;

function audio(nombre) {
    if (!ARCHIVOS[nombre]) return null;
    if (!audios[nombre]) {
        audios[nombre] = new Audio(ARCHIVOS[nombre]);
        audios[nombre].preload = 'auto';
    }
    return audios[nombre];
}

/**
 * El navegador no deja reproducir sonido hasta que la persona interactúa con
 * la página. Al primer clic o tecla se "despiertan" los audios en silencio, y
 * desde ahí los avisos suenan aunque la pestaña esté en segundo plano.
 */
export function prepararSonidos() {
    if (desbloqueado) return;

    const desbloquear = () => {
        desbloqueado = true;
        Object.keys(ARCHIVOS).forEach((nombre) => {
            const a = audio(nombre);
            a.muted = true;
            a.play().then(() => { a.pause(); a.currentTime = 0; a.muted = false; })
                .catch(() => { a.muted = false; });
        });
        window.removeEventListener('pointerdown', desbloquear);
        window.removeEventListener('keydown', desbloquear);
    };

    window.addEventListener('pointerdown', desbloquear);
    window.addEventListener('keydown', desbloquear);
}

/** Reproduce un sonido. Dos avisos en el mismo segundo suenan una sola vez. */
export function sonar(nombre) {
    const a = audio(nombre);
    if (!a) return;

    const ahora = Date.now();
    if (ahora - ultimoSonido < 1200) return;
    ultimoSonido = ahora;

    try {
        a.currentTime = 0;
        a.play().catch(() => { /* bloqueado: todavía no hubo un clic */ });
    } catch {
        /* sin audio en este navegador */
    }
}

export const escritorioDisponible = () => typeof window !== 'undefined' && 'Notification' in window;

export const permisoEscritorio = () => (escritorioDisponible() ? Notification.permission : 'denied');

/** Pide el permiso. Sólo funciona como respuesta a un clic de la persona. */
export async function pedirPermisoEscritorio() {
    if (!escritorioDisponible()) return 'denied';
    try {
        return await Notification.requestPermission();
    } catch {
        return Notification.permission;
    }
}

/**
 * Notificación del sistema operativo. Sólo cuando la pestaña no está a la
 * vista: si la persona está mirando el CRM ya ve la campana y oye el sonido.
 */
export function avisoDeEscritorio({ titulo, cuerpo, etiqueta, alHacerClic }) {
    if (!escritorioDisponible() || Notification.permission !== 'granted' || !document.hidden) return;

    try {
        const n = new Notification(titulo, {
            body: cuerpo || '',
            icon: '/icon-192.png',
            badge: '/icon-192.png',
            // Misma etiqueta = reemplaza a la anterior en vez de apilarse.
            tag: etiqueta,
            silent: true, // el sonido lo pone el CRM, no el sistema
        });
        n.onclick = () => {
            window.focus();
            alHacerClic?.();
            n.close();
        };
    } catch {
        /* algunos navegadores móviles no permiten new Notification() */
    }
}

// ── Título que parpadea ──────────────────────────────────────────────────

let tituloOriginal = null;
let intervalo = null;

function detenerParpadeo() {
    if (intervalo) clearInterval(intervalo);
    intervalo = null;
    if (tituloOriginal !== null) document.title = tituloOriginal;
    tituloOriginal = null;
}

/** Alterna el título de la pestaña hasta que la persona vuelve a mirarla. */
export function parpadearTitulo(texto) {
    if (!document.hidden) return;

    if (tituloOriginal === null) tituloOriginal = document.title;
    if (intervalo) clearInterval(intervalo);

    let encendido = false;
    intervalo = setInterval(() => {
        encendido = !encendido;
        document.title = encendido ? `● ${texto}` : tituloOriginal;
    }, 1000);
}

if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) detenerParpadeo();
    });
}
